import { createFileRoute } from "@tanstack/react-router";
import RequireAuth from "@/components/auth/RequireAuth";
import PageGate from "@/components/auth/PageGate";
import Leaderboard from "@/pages/Leaderboard";

export const Route = createFileRoute("/_app/leaderboard")({
  component: () => (
    <PageGate pageKey="leaderboard"><RequireAuth title="Leaderboard"><Leaderboard /></RequireAuth></PageGate>
  ),
});
